import { persistentMap } from '@nanostores/persistent';

export type AI_Model = 'dev-ai-model' | 'prod-ai-model' | 'dev-mock-ai-model';

import type { Framework, Language } from '~/lib/stores/techStackSelection';

type projectSource = 'github' | 'community_template' | 'alpha_template';

export type SelectionValues = {
  projectName: string;
  temporaryProjectRules: string;
  netlifyAccessToken: string;
  netlifySiteId: string;
  netlifySiteUrl: string;
  githubAccessToken: string;
  aiModel: AI_Model;
  framework: Framework;
  language: Language;
  presetModalView: 'presets' | 'custom';
  rememberCustomStack: 'true' | 'false';
  hasInteractedWithModal: 'true' | 'false';
  projectSource?: projectSource;
};

export const selectionStore = persistentMap<SelectionValues>('selection', {
  projectName: 'Untitled',
  aiModel: 'dev-mock-ai-model',
  temporaryProjectRules: '',
  githubAccessToken: '',
  netlifyAccessToken: '',
  netlifySiteId: '',
  netlifySiteUrl: '',
  framework: 'react_tailwind',
  language: 'ts',
  presetModalView: 'presets',
  rememberCustomStack: 'true',
  hasInteractedWithModal: 'false',
  projectSource: undefined,
});
